module.exports = __webpack_public_path__ + "img/haibao5@2x.5d352347.png";